(function () {
  'use strict';

  /*
   * MARIA ORBAI
   * Compatibilidad global de vídeos autoplay
   * Especialmente Safari / iOS
   */

  var registeredVideos = new WeakSet();

  function isAutoplayVideo(video) {
    return (
      video &&
      video.tagName === 'VIDEO' &&
      video.hasAttribute('autoplay')
    );
  }

  function prepareVideo(video) {
    if (!isAutoplayVideo(video)) return;

    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  }

  function isVisible(video) {
    if (!video || !video.isConnected) return false;

    var rect = video.getBoundingClientRect();
    var style = window.getComputedStyle(video);

    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      rect.width <= 0 ||
      rect.height <= 0
    ) {
      return false;
    }

    var viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight;

    return (
      rect.bottom > -100 &&
      rect.top < viewportHeight + 100
    );
  }

  function playVideo(video) {
    if (!isAutoplayVideo(video)) return;
    if (!isVisible(video)) return;

    prepareVideo(video);

    try {
      var playPromise = video.play();

      if (
        playPromise &&
        typeof playPromise.catch === 'function'
      ) {
        playPromise.catch(function () {
          /*
           * Si Safari rechaza temporalmente el autoplay,
           * volveremos a intentarlo al entrar en pantalla,
           * al volver a la página o tras una interacción.
           */
        });
      }
    } catch (error) {}
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          playVideo(entry.target);
        }
      });
    },
    {
      threshold: 0.01,
      rootMargin: '150px 0px'
    }
  );

  function registerVideo(video) {
    if (!isAutoplayVideo(video)) return;
    if (registeredVideos.has(video)) return;

    registeredVideos.add(video);

    prepareVideo(video);
    observer.observe(video);

    video.addEventListener(
      'loadeddata',
      function () {
        playVideo(video);
      }
    );

    video.addEventListener(
      'canplay',
      function () {
        playVideo(video);
      }
    );

    if (isVisible(video)) {
      playVideo(video);
    }
  }

  function scanVideos(root) {
    if (!root) return;

    if (root.tagName === 'VIDEO') {
      registerVideo(root);
      return;
    }

    if (!root.querySelectorAll) return;

    root
      .querySelectorAll('video[autoplay]')
      .forEach(function (video) {
        registerVideo(video);
      });
  }

  function playVisibleVideos() {
    document
      .querySelectorAll('video[autoplay]')
      .forEach(function (video) {
        playVideo(video);
      });
  }

  var mutationObserver = new MutationObserver(
    function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            scanVideos(node);
          }
        });
      });
    }
  );

  function init() {
    scanVideos(document);

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    playVisibleVideos();
  }

  document.addEventListener(
    'pointerdown',
    playVisibleVideos,
    {
      once: true,
      passive: true,
      capture: true
    }
  );

  document.addEventListener(
    'visibilitychange',
    function () {
      if (!document.hidden) {
        playVisibleVideos();
      }
    }
  );

  window.addEventListener(
    'pageshow',
    playVisibleVideos
  );

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      scanVideos(event.target);
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();